import { t } from "../../context/Preferences";
import React, { useState } from "react";
import axios from "axios";
import config from "../../config/config";
import moment from "moment";
import "moment/locale/tr";
import { FiX, FiInfo, FiTag, FiCalendar, FiCheckCircle } from "react-icons/fi";
import { useLoading } from "../../context/LoadingContext";
import "./CreateKazaDebtModal.css";
function CreateKazaDebtModal({ isOpen, onClose, onSuccess }) {
  const { setIsLoading } = useLoading();
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [submitting, setSubmitting] = useState(false);
  const handleCreate = async () => {
    if (!name.trim()) {
      alert("Lütfen bir isim girin");
      return;
    }
    setSubmitting(true);
    setIsLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const response = await axios.post(
        `${config.api_base}/api/kaza/create`,
        {
          name: name.trim(),
          startDate: moment(startDate).toISOString(),
        },
        {
          headers: {
            Authorization: `Bearer ${user._id}`,
          },
        }
      );
      if (response.data.statusCode === 200) {
        alert("Kaza borcu başarıyla oluşturuldu!");
        setName("");
        setStartDate(moment().format("YYYY-MM-DD"));
        onSuccess();
        onClose();
      } else {
        alert(response.data.message || "Bir hata oluştu");
      }
    } catch (error) {
      console.error("Kaza borcu oluşturma hatası:", error);
      alert("Kaza borcu oluşturulurken bir hata oluştu");
    } finally {
      setSubmitting(false);
      setIsLoading(false);
    }
  };
  if (!isOpen) return null;
  const daysSince = moment().diff(moment(startDate), "days");
  return (
    <div className="create-modal-overlay" onClick={onClose}>
      <div
        className="create-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="create-modal-header">
          <h2>{t("Yeni Kaza Borcu")}</h2>
          <button className="close-btn" onClick={onClose}>
            <FiX size={24} />
          </button>
        </div>

        {/* Info Card */}
        <div className="info-card">
          <FiInfo size={20} />
          <p>
            {t(
              "Farklı dönemler için ayrı kaza borçları oluşturabilirsiniz. Her borç kendi başlangıç tarihinden itibaren hesaplanır."
            )}
          </p>
        </div>

        {/* Form */}
        <div className="create-form">
          {/* Name Input */}
          <div className="form-group">
            <label>{t("Borç İsmi")}</label>
            <p className="form-description">
              {t("Bu kaza borcuna tanımlayıcı bir isim verin")}
            </p>
            <div className="input-with-icon">
              <FiTag size={18} />
              <input
                type="text"
                placeholder={t("Örn: 2020-2022 Borçlarım")}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>

          {/* Date Input */}
          <div className="form-group">
            <label>{t("Başlangıç Tarihi")}</label>
            <p className="form-description">
              {t("Kaza borcunun başladığı tarihi seçin")}
            </p>
            <div className="input-with-icon">
              <FiCalendar size={18} />
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                max={moment().format("YYYY-MM-DD")}
              />
            </div>
          </div>

          {/* Preview Card */}
          <div className="preview-card">
            <h3>{t("Önizleme")}</h3>
            <div className="preview-row">
              <span className="preview-label">{t("İsim:")}</span>
              <span className="preview-value">{t(name || "Kaza Borcum")}</span>
            </div>
            <div className="preview-row">
              <span className="preview-label">{t("Başlangıç:")}</span>
              <span className="preview-value">
                {moment(startDate).format("DD MMMM YYYY")}
              </span>
            </div>
            <div className="preview-row">
              <span className="preview-label">{t("Geçen Süre:")}</span>
              <span className="preview-value">
                {t(daysSince)}
                {t(" gün")}
              </span>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="create-modal-buttons">
          <button
            className="create-submit-btn"
            onClick={handleCreate}
            disabled={submitting}
          >
            <FiCheckCircle size={20} />
            <span>
              {t(submitting ? "Oluşturuluyor..." : "Kaza Borcu Oluştur")}
            </span>
          </button>
          <button className="create-cancel-btn" onClick={onClose}>
            {t("İptal")}
          </button>
        </div>
      </div>
    </div>
  );
}
export default CreateKazaDebtModal;
